import React from 'react';

import { Button } from '@alfalab/core-components/button';
import { Gap } from '@alfalab/core-components/gap';
import { GenericWrapper } from '@alfalab/core-components/generic-wrapper';
import { Typography } from '@alfalab/core-components/typography';

import { isNumber } from './is-number';

const PhoneHint = ({ message }: { message: string }) => (
    <React.Fragment>
        <GenericWrapper>
            <Typography.Text color='primary'>
                Отправили на&nbsp;{message}. Если номер сменился, обновите его на&nbsp;сайте Alfa
                People в сервисе <strong>Персональные данные</strong>. Войдите на&nbsp;сайт
                с&nbsp;рабочего компьютера или через удалённый рабочий стол.
            </Typography.Text>
        </GenericWrapper>
        <Gap size='xl' />
        <GenericWrapper alignItems='center'>
            <Typography.Text color='primary' style={{ textAlign: 'center' }}>
                Если номер тот&nbsp;же&nbsp;&mdash; попробуйте запросить код через пару минут или
                позвоните в&nbsp;HelpDesk.
            </Typography.Text>
        </GenericWrapper>
    </React.Fragment>
);

const EmailHint = ({ message }: { message: string }) => (
    <React.Fragment>
        <GenericWrapper>
            <Typography.Text color='primary'>
                Отправили на&nbsp;почту {message} Если письма с&nbsp;кодом нет&nbsp;&mdash;
                загляните в&nbsp;папку со&nbsp;спамом.
            </Typography.Text>
        </GenericWrapper>
        <Gap size='xl' />
        <GenericWrapper alignItems='center'>
            <Typography.Text color='primary'>
                Если и&nbsp;там пусто, попробуйте запросить новый код через пару минут или позвоните
                в&nbsp;HelpDesk.
            </Typography.Text>
        </GenericWrapper>
    </React.Fragment>
);

export const CustomHindComponent = ({ source, action }: { source: string; action: () => void }) => {
    const isPhone = isNumber(source);
    const message = source && isNumber(source) ? `+7 … … .. ${source}` : `${source}@alfabank.ru`;

    return (
        <GenericWrapper alignItems='center' column={true}>
            <GenericWrapper>
                <Typography.Title view='small' font='system' tag='div' color='primary'>
                    Не приходит код?
                </Typography.Title>
            </GenericWrapper>
            <Gap size='xl' />
            <div className='textAlignCenter'>
                {isPhone ? <PhoneHint message={message} /> : <EmailHint message={message} />}
            </div>

            <Gap size='2xl' />
            <GenericWrapper alignItems='center'>
                <Button view='secondary' size='s' onClick={action}>
                    Вернуться
                </Button>
            </GenericWrapper>
        </GenericWrapper>
    );
};
